import type { log } from 'console'; import type { log } from 'console';
<template>
  <div class="form-contact">
    <FormKit
      v-model="userData"
      type="form"
      :actions="false"
      @submit="onSubmit"
      id="requestForm"
    >
      <div class="form-contact__grid">
        <!-- Request Type -->
        <FormKit
          type="select"
          select-icon="down"
          :placeholder="$t('form.requestTypeLabel')"
          :label="$t('form.requestType')"
          name="requestType"
          validation="required"
          :options="$t('form.requestTypes').split(',')"
        />

        <!-- Country  -->
        <FormKit
          type="select"
          select-icon="down"
          :placeholder="$t('form.country')"
          :label="$t('form.countryLabel')"
          name="country"
          validation="required"
          :options="countryList"
        />

        <!-- Name -->
        <FormKit
          type="text"
          name="name"
          :label="$t('form.nameLabel')"
          validation="required"
          :placeholder="$t('form.name')"
        />

        <!-- Surname -->
        <FormKit
          type="text"
          name="surname"
          :label="$t('form.surnameLabel')"
          validation="required"
          :placeholder="$t('form.surname')"
        />

        <!-- Company -->
        <FormKit
          type="text"
          name="company"
          :label="`${$t('form.companyLabel')} (${$t('form.optional')})`"
          :placeholder="$t('form.company')"
        />

        <!-- Role -->
        <FormKit
          type="select"
          select-icon="down"
          :placeholder="$t('form.role')"
          :label="`${$t('form.roleLabel')} (${$t('form.optional')})`"
          name="role"
          :options="$t('form.roles').split(',')"
        />

        <!-- Email -->
        <FormKit
          type="email"
          name="email"
          :label="$t('form.emailLabel')"
          validation="required|email"
          :placeholder="$t('form.email')"
        />

        <!-- Telephone -->
        <FormKit
          type="text"
          name="phone"
          :label="$t('form.phoneLabel')"
          validation="required"
          :placeholder="$t('form.phone')"
        />

        <!-- Messaggio -->
        <FormKit
          type="textarea"
          name="message"
          :label="$t('form.message')"
          validation="required"
          :placeholder="$t('form.messageLabel')"
          rows="6"
        />
      </div>
      <!-- CHECKBOX -->
      <FormKit
        type="checkbox"
        name="terms"
        validation="accepted"
        :validation-messages="{ accepted: $t('form.termsError') }"
      >
        <template #label="context">
          <p
            class="text-s"
            v-html="
              $t('form.termsExtLabel', {
                url: localePath({
                  name: 'policy-privacy',
                }),
              })
            "
          />
        </template>
      </FormKit>

      <div class="form-contact__cta">
        <button
          type="submit"
          class="button-round-1 --dark form-contact__submit"
        >
          {{ $t('cta.sendRequest') }}
        </button>
      </div>
    </FormKit>
  </div>
</template>

<script>
export default {
  name: 'FormContact',
}
</script>

<script setup>
import { countryList } from '@/bucket/country-list.js'

import { load } from 'recaptcha-v3'
import { reset } from '@formkit/core'

const emit = defineEmits(['contacts-success', 'contacts-failure'])

const runtimeConfig = useRuntimeConfig()
const { t } = useI18n()

const userData = ref(null)
const loading = ref(false)

const postinApiId = t('form.apiContactFormPostinId')

const onSubmit = (formkitData, node) => {
  node.clearErrors()

  loading.value = true

  // TODO: Sistemare i catch del captcha da Postin. NON VIENE MAI ESEGUITO perchè ritorna un text.

  load(runtimeConfig.public.recaptchaKey).then((recaptcha) => {
    recaptcha.hideBadge()
    recaptcha.execute('postin').then((token) => {
      const formData = new FormData()

      formData.append('captcha', token)
      formData.append('api_id', postinApiId)

      formData.append('requestType', formkitData.requestType)
      formData.append('country', formkitData.country)
      formData.append('name', formkitData.name)
      formData.append('surname', formkitData.surname)
      formData.append('company', formkitData.company)
      formData.append('role', formkitData.role)
      formData.append('email', formkitData.email)
      formData.append('phone', formkitData.phone)
      formData.append('message', formkitData.message)
      formData.append('terms', formkitData.terms)

      // ID del template mail di postin

      fetch(runtimeConfig.public.postinURL, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          loading.value = false

          if (response.status === 200) {
            emit('contacts-success')
            reset(node)
          } else {
            emit('contacts-failure')
          }
        })
        .catch((e) => {
          loading.value = false
          emit('contacts-failure')
        })
    })
  })
}
</script>

<style lang="scss">
@import './style.scss';
</style>
